class Debugger {
  static ToggleDebugger() {
    window['metalheaven-debugger'] = !window['metalheaven-debugger'] || true
  }

  static Log(
    type: 'warning' | 'info' | 'error',
    message: string,
    ...optionalParams: unknown[]
  ) {
    if (window['metalheaven-debugger']) {
      switch (type) {
        case 'warning':
          console.warn(message, JSON.stringify(optionalParams))
          break
        case 'info':
          console.info(message, JSON.stringify(optionalParams))
          break
        case 'error':
          console.error(message, JSON.stringify(optionalParams))
          break
      }
    }
  }

  static Configure() {
    if (process.env.NODE_ENV === 'development') {
      window['metalheaven-debugger'] = false
    }
  }
}

export { Debugger }
